import React, { useContext } from 'react'
import {
    Switch,
    Route
} from 'react-router-dom'
import TransferNumber from './transfer-number/TransferNumber'

import NumberPicker from 'number-picker'
import Link from '../../design-components/Link'
import { Typography, Button } from 'foundations-library/components'
import { makeStyles, Theme } from '@material-ui/core'
import LeadContext from '../../LeadContext'

const useStyles = makeStyles((theme: Theme) => {
    const { colors } = theme['foundations-library']

    return {
        footer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
            marginTop: '30px',
            width: 'min(100%, 670px) !important',
            margin: 'auto',
            borderTop: `1px solid ${colors.neutral[100]}`,
            [theme.breakpoints.up('md')]: {
                maxWidth: 'none',
                flexWrap: 'nowrap'
            },
            color: '#364047',
            '& svg': {
                width: '18px',
                height: '18px'
            },
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
                gap: 0
            }
        },
        footerLink: {
            display: 'block',
            [theme.breakpoints.up('md')]: {
                display: 'inline'
            }
        },
        alreadyHaveANumberText: {
            color: colors.neutral[900]
        },
        transferNumberButton: {
            color: colors.primary[500],
            border: 0,
            cursor: 'pointer'
        }
    }
})

const basePath = '/pick-a-number'

/**
 * Pick a number step of sign-up
 */
const PickANumber = () : JSX.Element => {
    const classes = useStyles()

    const leadContextValue = useContext(LeadContext)

    const { cart } = leadContextValue.leadParams

    let numberPickerErrorMessage = null
    if (cart?.some(item => item.status === 'number_expired')) {
        numberPickerErrorMessage = 'number_expired'
    } else if (cart?.some(item => item.status !== 'number_available')) {
        numberPickerErrorMessage = 'cart_number_not_available'
    }

    return (
        <Switch>
            <Route exact path={basePath}>
                <>

                    <NumberPicker
                        recommendANumber={true}
                        errorMessage={numberPickerErrorMessage}
                    />

                    <div className={classes.footer}>
                        <Typography variant="body2" className={classes.alreadyHaveANumberText}>Already have a number you love?</Typography>
                        <Link className={classes.footerLink} to="/pick-a-number/transfer">
                            <Button className={classes.transferNumberButton} variant="text" size="medium" icon={'go'}>Transfer your number to Phone.com</Button>
                        </Link>
                    </div>
                </>
            </Route>
            <Route path={`${basePath}/transfer`}>
                <TransferNumber />
            </Route>
        </Switch>
    )
}

export default PickANumber
